<div class="workspace-catalog-header mb-2 mx-2 mt-2 pb-3">
  <div class="d-flex justify-content-between">
    <h3>Workspace Catalog</h3>
    <button
      nf-icon-button="secondary"
      icon="close"
      class="btn-bare close"
      ngbTooltip="Close Workspace Catalog"
      (click)="closePanel.emit()"
    >
      Close Workspace Catalog
    </button>
  </div>
  <div class="workspace-button-section ml-0">
    <hs-workspace-create-from-button
      (createFromWorkspacePrefix)="cloneWorkspace($event)"
    ></hs-workspace-create-from-button>
    <button nf-button="create" (click)="cloneActiveWorkspace()">Create</button>
  </div>
  <nf-search
    placeholder="Search Workspace Catalog"
    [formControl]="workspaceSearch"
  >
  </nf-search>
</div>
<div class="workspace-card-section">
  <hs-workspace-category
    title="Custom Workspaces"
    [isPreset]="false"
    [workspaces]="filteredCustomWorkspaces"
    [defaultWorkspacePrefix]="defaultWorkspacePrefix"
    (cloneWorkspace)="cloneWorkspace($event)"
  ></hs-workspace-category>
  <hs-workspace-category
    title="Preset Workspaces"
    [isPreset]="true"
    [workspaces]="filteredPresetWorkspaces"
    (cloneWorkspace)="cloneWorkspace($event)"
  ></hs-workspace-category>
</div>
